import { NetworkConfigType, NetworkInfoType } from "./types";

// Images
import bnbIcon from "assets/svg/bnb-light.svg";
import bnbDarkIcon from "assets/svg/bnb-dark.svg";
import bnbxIcon from "assets/svg/bnbx-light.svg";
import bnbxDarkIcon from "assets/svg/bnbx-dark.svg";

// ABI
import ERC20TOKENABI from "contracts/mainnet/ERC20.json";
import TokenXABI from "contracts/mainnet/TokenXBal.json";
import TokenXInteractionABI from "contracts/mainnet/TokenXInteractionPool.json";
import KOLReferral from "contracts/testnet/KOLReferral.json";

export const MainNetConfig: NetworkConfigType = {
  chainId: "0x38",
  rpcUrl: "https://bsc-mainnet.nodereal.io/v1/8438d9c512534d20a2367b930e8863e3",
  chainName: "Smart Chain",
  network: "bsc-mainnet",
  nativeCurrency: {
    name: "Binance",
    symbol: "BNB",
    xsymbol: "BNBx",
    decimals: 18,
  },
  blockExplorerUrls: ["https://bscscan.com"],
  contractAddresses: {
    erc20: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
    xtoken: {
      token: "0x1bdd3Cf7F79cfB8EdbB955f20ad99211551BA275",
      interactionPool: "0x7276241a669489E4BBB76f63d2A43Bfe63080F2F",
    },
    referral: "0xa76B46b181B09cC25D02eA412e499E3afbA4c372",
  },
  abis: {
    erc20: ERC20TOKENABI,
    xtoken: {
      token: TokenXABI,
      interactionPool: TokenXInteractionABI,
    },
    referral: KOLReferral,
  },
};

export const NetworkInfo: NetworkInfoType = {
  icon: {
    light: bnbIcon,
    dark: bnbDarkIcon,
  },
  tokenXIcon: {
    light: bnbxIcon,
    dark: bnbxDarkIcon,
  },
};
